import { AboutDialog } from './AboutDialog';
import { ChangeOperatorDialog } from './ChangeOperatorDialog';
import { ClockAdjustDialog } from './ClockAdjustDialog';
import { CodeWordsEditor } from './CodeWordsEditor';
import { ConnectServerDialog } from './ConnectServerDialog';
import { DocsDialog } from './DocsDialog';
import { DownloadDesktopDialog } from './DownloadDesktopDialog';
import { ExportDialog } from './ExportDialog';
import { ScheduledRemindersDialog } from './ScheduledRemindersDialog';
import { ServerSettingsDialog } from './ServerSettingsDialog';
import { TagsEditor } from './TagsEditor';
import { TemplateEditor } from './TemplateEditor';
import { $dialog, type Dialog } from '@/stores/dialog';
import { useStore } from '@nanostores/react';
import type { ReactNode } from 'react';

export function Dialogs() {
  const openDialog = useStore($dialog);

  return (
    (
      {
        about: <AboutDialog />,
        changeOperator: <ChangeOperatorDialog />,
        clockAdjust: <ClockAdjustDialog />,
        codewords: <CodeWordsEditor />,
        docs: <DocsDialog />,
        export: <ExportDialog />,
        scheduledReminders: <ScheduledRemindersDialog />,
        serverSettings: <ServerSettingsDialog />,
        connectServer: <ConnectServerDialog />,
        tags: <TagsEditor />,
        template: <TemplateEditor />,
        downloadDesktop: <DownloadDesktopDialog />,
      } satisfies Record<Dialog, ReactNode>
    )[openDialog as string] || null
  );
}
